import styled from 'styled-components';
import { rgba } from 'polished';

export const InputWrapper = styled.div`
	display: inline-flex;
	flex-direction: row;
	align-items: flex-end;
	width: 50%;
	margin-bottom: 19px;
	&:nth-child(odd) {
		padding-right: 32px;
	}

	&:nth-child(even) {
		padding-left: 32px;
	}
`;

export const ColorPreview = styled.div`
	height: 43px;
	min-width: 43px;
	box-shadow: 0 2px 8px 0 ${rgba('#000', 0.1)};
	margin-left: 15px;
`;
